import { ErrorCode } from '@app/routing/RouterToaster'

const docErrors = [
  'documents_not_provided',
  'document_filename_exists',
  'document_already_uploaded',
  'invalid_document',
  'invalid_document_status',
  'invalid_document_status_reason',
  'invalid_document_category',
  'upload_file_max_size_limit',
  'client_not_found',
]

export const isDocError = (errorMessage: ErrorCode): boolean => docErrors.includes(errorMessage)

export const getDocUploadFailMessage = (errorMessage?: string): string => {
  switch (errorMessage) {
    case 'documents_not_provided':
      return 'errors.Documents were not provided'
    case 'document_filename_exists':
    case 'document_already_uploaded':
      return 'errors.The Document has already been uploaded'
    case 'invalid_document':
      return "errors.We couldn't read your document"
    case 'invalid_document_status':
      return "errors.This document has been removed and can't be updated"
    case 'invalid_document_status_reason':
      return "errors.This document has been removed and can't be updated"
    case 'invalid_document_category':
      return 'errors.Check your category choice'
    case 'upload_file_max_size_limit':
      return 'errors.Cannot upload file because its size is over allowed limit'
    case 'client_not_found':
      return 'errors.Client not found'
    default:
      return 'Upload failed'
  }
}
